import { classNames } from '../../utils';

const BaseContainer = ({ className, children }) => {
  return <section className={classNames(className, 'px-6 mx-auto max-w-xl transition-all duration-300 md:px-10 md:max-w-5xl xl:max-w-[1300px]')}>{children}</section>;
};

export default BaseContainer;
